import * as _ from 'lodash';
import { IContact } from '@nkr/models/index';
import { Button, Col, FormGroup, FormControl, ControlLabel, Modal, Radio, Alert, Label } from 'react-bootstrap'
import styled from 'styled-components';

const FormGroupWrapper = styled(FormGroup)`
    display: flex;
    align-items: center;
`;

interface IProps {
    show: boolean,
    donorId: number,
    coordinatorList: IContact[],
    coordinatorId: number,
    validation: {
        coordinatorIdValid: boolean
    },
    onCoordinatorChange: (coordinatorId: number) => void,
    onConfirm: (donorId: number) => void,
    onCancel: () => void
}

const RecipientCenterCoordinatorConfirm = (props: IProps) => {
    const handleCoordinatorChange = (coordinatorId: number) => {
        props.onCoordinatorChange(coordinatorId);
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Recipient Center Coordinator Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.coordinatorList && (
                    <div style={{ marginBottom: 20 }}>

                        <Alert bsStyle='info'>
                            Before proceeding to transfer the donor, please select the recipient center coordinator from the list below.
                        </Alert>

                        <FormGroupWrapper validationState={!props.validation.coordinatorIdValid ? 'error' : null}>
                            <Col componentClass={ControlLabel} sm={5}>
                                Primary Coordinator:
                            </Col>
                            <Col sm={5}>
                                <FormControl
                                    componentClass='select'
                                    bsSize='xs'
                                    value={props.coordinatorId}
                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => handleCoordinatorChange(parseInt(e.currentTarget.value))}
                                >
                                    <option value={-1}>- Not Assigned -</option>
                                    {props.coordinatorList != null && (
                                        props.coordinatorList.map((item) => {
                                            return <option key={_.uniqueId("co")} value={item.id}>{item.fullName}</option>
                                        })
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroupWrapper>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={() => props.onConfirm(props.donorId)}>Proceed to Transfer Donor</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RecipientCenterCoordinatorConfirm;